// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ev-0";
export var fileCarousel = "_ev-2";
export var removeFileButton = "_ev-1";